import type { ClientCancellationSuspensionPolicyDto } from '../../types/clientCancellationLines';
import { CLIENT_CANCELLATION_SUSPENSION_BLOCK_MESSAGE } from './clientCancellationLinesLabels';

/** `false` só quando a API envia explicitamente `suspensaoPermitida: false`. */
export function contratoPermiteSuspensao(
  suspensaoPermitida: boolean | null | undefined
): boolean {
  return suspensaoPermitida !== false;
}

export function mensagemSuspensaoBloqueada1056(
  policy?: ClientCancellationSuspensionPolicyDto | null
): string {
  const msg = policy?.message?.trim();
  return msg || CLIENT_CANCELLATION_SUSPENSION_BLOCK_MESSAGE;
}

export function deveExibirBannerPoliticaSuspensao(
  policy?: ClientCancellationSuspensionPolicyDto | null
): boolean {
  return policy?.blockNewSuspensions === true;
}

/** Novo contrato (sem id de edição) sujeito à política de fim da suspensão. */
export function politicaBloqueiaSuspensaoEmNovoContrato(
  editingContractId: string | null | undefined,
  policy?: ClientCancellationSuspensionPolicyDto | null
): boolean {
  return !editingContractId && policy?.blockNewSuspensions === true;
}

/**
 * Bloqueia o fluxo legado de suspensão de linhas no formulário de contrato:
 * contrato existente com `suspensaoPermitida === false`, ou novo contrato com `blockNewSuspensions`.
 */
export function formularioBloqueiaFluxoSuspensaoLinhas(params: {
  editingContractId?: string | null;
  suspensaoPermitidaContrato?: boolean | null;
  policy?: ClientCancellationSuspensionPolicyDto | null;
}): boolean {
  if (params.suspensaoPermitidaContrato === false) return true;
  return politicaBloqueiaSuspensaoEmNovoContrato(params.editingContractId, params.policy);
}
